// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__XCa8P","rootSuccess":"CompleteLink_rootSuccess__1R_fB","rootFailure":"CompleteLink_rootFailure__NWyw1","isDisabled":"CompleteLink_isDisabled__1-uGH"};